/* 🤖 this file was generated by svg-to-ts */
export const matIconMovieFilter: {
  name: 'movie-filter';
  data: string;
} = {
  name: 'movie-filter',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m10 11-.94 2.06L7 14l2.06.94L10 17l.94-2.06L13 14l-2.06-.94zm8.01-7 2 4h-3l-2-4h-2l2 4h-3l-2-4h-2l2 4h-3l-2-4h-1c-1.1 0-1.99.9-1.99 2l-.01 12c0 1.1.9 2 2 2h16c1.1 0 1.99-.9 1.99-2V4h-3.99zm2 14h-16V6.47L5.77 10H16l-.63 1.37L14 12l1.37.63L16 14l.63-1.37L18 12l-1.37-.63L16 10h4.01v8z"/></svg>`
};
